/// <reference path="BaseField.ts" />

namespace MACRAIL.Forms.Fields {

export class Otherable extends BaseField {

    protected opts: OtherableOptions;

    private addedOther: boolean = false;
    private otherCount: number = 0;
    private otherContainer: JQuery | undefined;
    private valueElement: JQuery | undefined;
    private otherLabel: JQuery | undefined;
    private qTip: QTip2.Api;

    private popupOpen = false;

    constructor (element: string | JQuery, opts: OtherableOptions = {}) {
        super(element, opts);

        this.element.on('change', (e) => {
            this.updateValueElement();
        });
    }

    public addOption (id: number | string, label: string) {

        this.element.hide();

        let elementId = this.element.prop('id');

        // Would like to get rid of this child div as it causes styling issues.
        if (!this.addedOther) {
            this.addedOther = true;
            this.valueElement = $(`
                <div class="otherable-value form-control">
                    <span></span>
                    <i class="fa fa-caret-down"></i>
                </div>
            `);
            this.valueElement.insertBefore(this.element);
            this.updateValueElement();

            this.valueElement.on('click', () => {
                if (this.popupOpen) {
                    this.qTip.show();
                } else {
                    this.qTip.show();
                }
            });

            this.otherContainer = $('<div class="boxset"></div>');
            this.otherContainer.insertBefore(this.element);

            this.otherLabel = $(
                `<label for="${elementId}-other">` +
                `<input type="radio" id="${elementId}-other" name="${elementId}-others" /> ` +
                `Other` +
                `</label>`);
            this.otherContainer.append(this.otherLabel);

            // Hack to avoid a bug in IE 11. The real element is appended to a label, but clicking a label focuses the
            // first input inside it. Therefore the real element click event bubbles up, ends up focusing the checkbox,
            // and then immediately de-focusing the real element. This prevents that.
            this.otherLabel.on('click', (e) => {
                if (e.target.tagName !== 'LABEL' && (e.target as HTMLInputElement).type !== 'radio') {
                    e.preventDefault();
                    e.stopPropagation();
                }
            });

            this.otherLabel.append(this.element);
            this.otherContainer.hide();

            this.otherContainer.on('click', 'input[type="radio"]', (e) => {
                const input = $(e.currentTarget);
                const labelElement = input.parent();

                this.otherContainer.find('label').removeClass('active');
                labelElement.addClass('active');

                let newValue = input.data('value');

                if (newValue !== undefined) {
                    this.setElementValue(newValue);

                    this.element.hide();
                    this.element.trigger('change');
                } else {
                    newValue = this.element.find('option:first-child').val();
                    this.element.val(newValue);
                    this.value = newValue;

                    this.element.show();
                    if (this.element.attr('type') === 'text') {
                        this.element.focus();
                    }
                }

                this.updateValueElement();

                if (!labelElement.is(':last-child')) {
                    setTimeout(() => {
                        this.qTip.hide();
                    }, 200);
                }
            });

            this.qTip = MACRAIL.Helpers.createQtip({
                'content': this.otherContainer,
                'position': 'below',
                'target': this.valueElement,
            });
        }

        this.otherLabel.before(
            `<label for="${elementId}-${this.otherCount}">` +
            // tslint:disable-next-line:max-line-length
            `<input type="radio" id="${elementId}-${this.otherCount}" data-value="${id}" name="${elementId}-others" /> ` +
            `${label}` +
            // tslint:disable-next-line:trailing-comma
            `</label>`
        );


        this.otherCount++;
    }

    public clearOptions() {
        if (!this.otherContainer) {
            return;
        }

        this.valueElement
            .parent()
            .append(this.element);
        this.otherContainer.remove();
        this.otherContainer = undefined;
        this.otherLabel = undefined;
        this.valueElement.remove();
        this.valueElement = undefined;
        this.element.show();
        this.addedOther = false;
        this.otherCount = 0;
        this.qTip.destroy(true);
    }

    public setValue(newValue: any) {

        if (newValue === this.element.val()) {
            return;
        }

        if (newValue === undefined) {
            this.setElementValue(this.defaultValue);
            if (this.addedOther) {
                this.otherContainer.parent()
                    .find('input:checked')
                    .prop('checked', false)
                    .parent()
                    .removeClass('active');
                this.element.hide();
            }
        } else {
            let foundInOthers = false;

            // Try an find it in the main list first.
            if (this.addedOther) {
                let input = this.otherContainer.find('input[data-value="' + newValue + '"]');

                if (input.length === 1) {
                    // 'Click' the option.
                    input.trigger('click');
                    foundInOthers = true;
                }
            }

            if (!foundInOthers) {
                // 'Click' the other option to show the 'other' input.
                if (this.otherLabel) {
                    this.otherLabel.find('[type="radio"]').trigger('click');
                }
                this.element.val(newValue);
            }
        }
        this.value = newValue;
        this.updateValueElement();

        this.setDirty(true);
    }

    public getValue() {
        let val = this.element.val();

        if (val === '-1') {
            return undefined;
        }

        return val;
    }

    public reset() {
        super.reset();

        this.clearOptions();
    }

    /*public showPopup() {
        if (!this.otherContainer) {
            return;
        }

        this.otherContainer.show();
        this.otherLabel.show();
        this.popupOpen = true;
    }

    public hidePopup() {
        if (!this.otherContainer) {
            return;
        }

        if (!this.addedOther) {
            this.otherLabel = $('<div>');
            this.addedOther = true;
        }

        this.otherContainer.hide();
        this.otherLabel.hide();
        this.popupOpen = false;
    }*/

    private setElementValue(newValue: any) {

        // HACK: Need a better way then using '-1' as an 'unselected' value.
        if (this.element.is('select') && newValue === undefined) {
            newValue = -1;
        }

        let oldValue = this.element.val();
        this.element.val(newValue);
        this.value = newValue;

        if (this.element.is('select') && this.element.val() === null) {
            this.element.val(oldValue);
            this.value = oldValue;
            // tslint:disable-next-line:no-console
            console.error(`Otherable '${this.name}' tried to set the value '${newValue}' which doesn't exist.`);
        }
        this.updateValueElement();
    }

    private updateValueElement() {
        if (!this.addedOther) {
            return;
        }

        let value = '';
        if (this.element.is('select')) {
            value = this.element.find('option:checked').text();
        } else {
            value = this.element.val();
        }
        this.valueElement.find('span').text(value);
        // this.hidePopup();
    }
}

interface OtherableOptions extends FieldOptions {
}

}
